<template>
  <div
    class="fixed inset-0 flex h-full flex-col items-center justify-center space-y-8 p-40"
  >
    <RevIllustration
      :alt="i18n(translations.bouyguesIcon)"
      :height="84"
      src="/img/bouygues/bouyguesTelecomLogo.svg"
      :width="105"
    />
    <h3 class="heading-3 text-center">{{ i18n(translations.title) }}</h3>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './Loading.translations'

const i18n = useI18n()
</script>
